import { useEffect, useState } from 'react'
import Renderer from '../classes/renderer'
import Shader from '../classes/shader'
import { ArtboardFilter } from '../types'

export function useShader(renderer: Renderer | null, filter?: ArtboardFilter, disabled: boolean = false) {
    const [state, setState] = useState<Shader | null>(null)

    useEffect(() => {
        if (!renderer || disabled) {
            setState(null)
            return
        }

        const shader = new Shader(renderer.gl, filter)

        setState(shader)
    }, [disabled, filter, renderer])

    return state
}
